// Accounts 4 and 5 are clones of accounts 3 and 2 respectively and share their UI behaviour.
const ACCOUNT_ALIASES = {
    "4": "3",
    "5": "2",
};

export const getEffectiveAccountId = (accountId) => {
    if (accountId === null || accountId === undefined || accountId === "") return accountId;
    const key = String(accountId);
    return ACCOUNT_ALIASES[key] ?? key;
};

export const getEffectiveAccountIdNumber = (accountId) => {
    const effective = getEffectiveAccountId(accountId);
    return effective === null || effective === undefined || effective === "" ? null : Number(effective);
};
